import { useState } from 'react';

import QaSpecCharacteristicGrid from './QaSpecCharacteristicGrid';

import { useGetQaSpecRequiredFieldsInQaSpecFullView } from 'pages/qa-spec/hooks/useGetQaSpecRequiredFields';
import { useOrganoleptic } from 'pages/qa-spec/hooks/useOrganoleptic';
import { useGetQaSpecCharacteristicsSnapshot } from './snapshot/hooks';

import { checkSectionRequired } from 'pages/qa-spec/utils';

import { EDIT_SECTION } from 'pages/qa-spec/components/edit-tab-checker';

const OrganolepticCharacteristic = (props) => {
  const { productId, productFull } = props;

  const { data: requiredFields } = useGetQaSpecRequiredFieldsInQaSpecFullView({
    productId,
  });

  const isSectionRequired = checkSectionRequired(
    requiredFields,
    'organoleptic'
  );

  const [isGridEditing, setIsGridEditing] = useState(false);

  const {
    gridInst,
    analysisNotExecuted, // TODO: Update it to analysisExecuted.
    rowData,
    columnDefs,
    saveData,
    cancelEdit,
    loading,
    onCellEditingStopped,
    gridTitle,
  } = useOrganoleptic({
    productId,
    isGridEditing,
    requiredFields,
    isSectionRequired,
  });
 
  const hiddenParameters = ['Workmanship', 'Function'];

  const filteredRowData =
    productFull?.type === 'Non-Food'
      ? rowData
      : rowData.filter(
        row => !hiddenParameters.includes(row.parameter)
      );

  const { analysisNotExecutedSnapshot, organolepticCharacteristicsSnapshot } =
    useGetQaSpecCharacteristicsSnapshot();

  const onEdit = (isEditing) => {
    setIsGridEditing(isEditing);
  };

  return (
    <QaSpecCharacteristicGrid
      type={EDIT_SECTION.PROD_SPEC_ORGANOLEPTIC}
      title={gridTitle}
      loading={loading}
      gridInst={gridInst}
      columnDefs={columnDefs}
      rowData={filteredRowData}
      handleSave={saveData}
      handleCancel={cancelEdit}
      analysisNotExecuted={analysisNotExecuted}
      analysisNotExecutedSnapshot={analysisNotExecutedSnapshot}
      isShowAnalysisNotExecuted
      productId={productId}
      onCellEditingStopped={onCellEditingStopped}
      snapshotGridValues={organolepticCharacteristicsSnapshot}
      onEditChange={onEdit}
      fieldPathTooltip='qaSpecification.productSpecification.analysisNotExecuted1'
    />
  );
};

export default OrganolepticCharacteristic;
